import { Link, makeStyles, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    legalLink: {
        color: 'white',
        lineHeight: '1.5',
        textDecoration: 'none',
        display: 'block',
        
        '&:hover': {
            opacity: 1,
            color: "white",
            textDecoration: 'underline',
        }
    }
});

const Legal = () => {
    const { t } = useTranslation("navigation");
    const styles = useStyles();

    return (
        <div>
            <Text block>{t("legal.title")}</Text>
            <Link href="/legal/terms" className={styles.legalLink}>{t("legal.policies.terms")}</Link>
            <Link href="/legal/privacy-policy" className={styles.legalLink}>{t("legal.policies.privacy")}</Link>
            <Link href="/legal/cookie-policy" className={styles.legalLink}>{t("legal.policies.cookies")}</Link>
            <Link href="/legal/recruitment-policy" className={styles.legalLink}>{t("legal.policies.recruitment")}</Link>
        </div>
    );
}

export default Legal;